import axios, { AxiosError } from 'axios';


export const errorInterceptor = (error: AxiosError) => {

   
  if (error.message === 'Network Error') {
    return Promise.reject(new Error('Erro de conexão.'));
  }

  if (error.response?.status === 401) {
    const isLoginRoute = window.location.pathname === '/login';

    if (!isLoginRoute) {
      localStorage.removeItem('APP_ACCESS_TOKEN');
      axios.defaults.headers.common.Authorization = '';
  
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }


  if (error.response?.status === 402) {
    //
  }

   if (error.response?.status === 400) {
    return Promise.reject(error);
  }


  return Promise.reject(error);
};